import React from 'react';
import download from '@/utils/downloads';
import { states } from '@/constants/lifecycle';
import DownloadAction from '@/components/ribbon-actions/DownloadAction';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import RequestAction from '../../components/RequestAction';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestMarkdownActions = ({ category, code, isOrphanedByDataset }) => {
  const { allowRead, readStatus, text } = Selectors.useRequestMarkdownActions({ category, code });
  const fetchData = Events.useFetchRequestMarkdown(category, { code });

  return (
    <>
      {allowRead && (
        <>
          {!isOrphanedByDataset && (
            <>
              <RequestAction code={code} />
              <RefreshActionMenu onClick={fetchData} readStatus={readStatus} />
            </>
          )}
          <DownloadAction
            disabled={readStatus !== states.SUCCESS}
            onClick={() => download.textDownload(text, `${code}_request.md`)}
          />
        </>
      )}
    </>
  );
};

export default RequestMarkdownActions;
